import { inject } from '@angular/core';
import { GamificacaoService, MenuIdentificador } from 'app/shared/services/edduca-imob/gamificacao/gamificacao.service';
import { GamificacaoHandler } from 'app/shared/components/gamificacao';
import { GlobalService } from 'app/shared/services/core';

/**
 * Hook para registrar acesso a menus para gamificação
 * Deve ser chamado no ngOnInit de cada página principal
 * 
 * Menus Plano 1: 'home', 'trilhas', 'aulas-ao-vivo', 'ia', 'ranking', 
 *                'feedbacks', 'comunicados', 'meu-perfil'
 * 
 * Menus Plano 2+: todos acima + 'conquistas', 'newsletter'
 * 
 * NOTA: A badge "Pronto para o Mercado" só é atribuída para plano 2+
 */
export function useMenuTracking() {
  const gamificacaoService = inject(GamificacaoService);
  const gamificacaoHandler = inject(GamificacaoHandler);
  const globalService = inject(GlobalService);
  
  /**
   * Registra o acesso a um menu específico
   * Só registra na primeira vez que o usuário acessa
   */
  const registrarAcessoMenu = (menu: MenuIdentificador): void => {
    const usuarioId = globalService.getIdUserLogged();
    if (!usuarioId) return;
    
    gamificacaoService.registrarAcessoMenu(usuarioId, menu).subscribe({
      next: (response) => {
        gamificacaoHandler.processarGamificacao(response);
      },
      error: () => {
        // Silenciosamente ignora erros de tracking
      }
    });
  };
  
  return { registrarAcessoMenu };
}
